import * as React from "react";
import { Fade, Grow } from "@mui/material";
import { useAnimation } from "../core/animation-provider";

export function TableAnimation({ children, delay, animationType = "fade" }: { children: React.ReactElement; delay?: number; animationType?: "fade" | "grow" }) {
	const { isAnimated, setIsAnimated } = useAnimation();

  const [isVisible, setIsVisible] = React.useState(isAnimated);
  
	React.useEffect(() => {
		const timer = setTimeout(() => {
			setIsVisible(true);

      setTimeout(() => {
        setIsAnimated(true);
      }, delay);
		}, delay);

		return () => clearTimeout(timer);
	}, [delay, setIsAnimated]);

  if (animationType === "fade") {
    return (
      <Fade in={isVisible} timeout={isAnimated ? 0 : delay}>
        {children}
      </Fade>
    );
  }

	return (
		<Grow  in={isVisible} timeout={isAnimated ? 0 : delay} >
			{children}
		</Grow>
	);
}
